import React from "react";
import { useTranslation } from "react-i18next";
import AppStoreBadges from "./AppStoreBadges";
import "./clientTheme.css";
import "./AppDownloadBanner.css";

export default function AppDownloadBanner() {
  const { t } = useTranslation("mainPage");

  return (
    <section className="app-download-banner">
      <div className="app-download-inner">
        <div className="app-download-text">
          <h2 className="app-download-title">{t("getOurAppTitle")}</h2>
          <p className="app-download-subtitle">{t("getOurAppSubtitle")}</p>
        </div>
        <AppStoreBadges />
      </div>
    </section>
  );
}
